






















































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  getList, ScoreColorsData, emptyData, postData, remove
} from '@/api/systemManage/scoreColors'
import PageForm from '@/components/pageLayout/form.vue'

@Component({
  components: {
    PageForm
  }
})
export default class ScoreColors extends Vue {
  public loading = false
  public collapseNames: string[] = ['base']

  public items: ScoreColorsData[] = []

  // dynamic component
  public $refs!: {
    formCtrl: PageForm
  }

  public arraySpanMethod(obj: { row: any, column: any, rowIndex: number, columnIndex: number }) {
    //字段名
    var span: number[] = []
    var item = obj.row
    /** 合并第一列（级别列）
     * 1.判断需要合并的行数RowSpan>0 
     * 2.合并[item.RowSpan, 1] item.RowSpan行，1列
     * 3.其他行删除 [0, 1] 0行1列
     */
    if (obj.columnIndex == 0) {
      span = item.RowSpan > 1 ? [item.RowSpan, 1] : [0, 1]
      return span
    }
  }
  public created() {
    this.fetchSource()
  }
  public fetchSource() {
  }
  public mounted() {
    this.fetchData()
  }
  public fetchData() {
    this.fetchItems()
  }
  public fetchItems() {
    this.loading = true
    getList().then((response: { data: any }) => {
      this.items = response.data
      this.loading = false
    })
  }
  public onCancel() {
    this.$router.push({ path: '/ScoreColors' })
  }
  public onSubmit() {
    postData(this.items).then((response: { data: any }) => {
      const data = response.data
      if (data && !data.IsError) {
        this.$message({
          message: `保存成功`,
          type: 'success'
        })
        this.fetchData()
        // this.$router.push({ path: '/ScoreColors' })
      } else {
        this.$message({
          dangerouslyUseHTMLString: true, message: `${data.Message}`,
          type: 'success'
        })
        console.log('保存失败', data)
      }
    }, (data: any) => {
      console.log(data);
    })
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
